class Pago {
    id = null;
    gateway = null;
    estado = null;
    tipo_comprobante = null;
    pre_comprobante = null;
    numero_comprobante = null;
    importe_total = null;
    unidad_id = null;
    usuario_id = null;

    constructor(obj) {
        // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
        for (var prop in obj) this[prop] = obj[prop];
    }
}

export default Pago;